import { app } from '../../../../../app';
import { Controller } from './approval-policies-edit.controller';

app.component('requestCenterPoliciesEdit', {
    bindings: {
        policies: '<',
        companyId: '<',
        defaultPolicy: '<',
        policy: '<',
    },
    controller: Controller,
    templateUrl: require('./approval-policies-edit.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/request-center/policies/edit/approval-policies-edit.component.js